module.exports = function () {
  return "\n    <div>\n      <h1>Store</h1>\n      <p>Store administration will be available here.</p>\n    </div>\n  ";
};